import { render, staticRenderFns } from "./VtagForm.vue?vue&type=template&id=79cc2fe5&scoped=true"
import script from "./VtagForm.vue?vue&type=script&lang=js"
export * from "./VtagForm.vue?vue&type=script&lang=js"
import style0 from "./VtagForm.vue?vue&type=style&index=0&id=79cc2fe5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc2fe5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cc2fe5')) {
      api.createRecord('79cc2fe5', component.options)
    } else {
      api.reload('79cc2fe5', component.options)
    }
    module.hot.accept("./VtagForm.vue?vue&type=template&id=79cc2fe5&scoped=true", function () {
      api.rerender('79cc2fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/transferRoute/components/form/VtagForm.vue"
export default component.exports